import {IAppRoute} from "../../application/config/IAppRoute";
import {routeDeviceMgtmSettingsPaths} from "./routeDeviceMgtmSettings.paths";
import {DeviceMgtmSettings} from "../pages/DeviceMgtmSettings";

export const routeDeviceMgtmSettings: IAppRoute = {
  ...routeDeviceMgtmSettingsPaths,
  render: () => <DeviceMgtmSettings/>,
};
